import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VScaleScreen from 'v-scale-screen';
// import api from './utils'
// Vue.prototype.$api = api
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VScaleScreen)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
